export const videoCodecs: { [key: string]: string } = {
  av1: 'video/mp4; codecs=av01.0.05M.08,opus',
  hevc: 'video/mp4; codecs=hvc1',
  h264: 'video/mp4; codecs=avc1.4D401E,mp4a.40.2',
};

export const videoCodecsTypes: string[] = ['av1', 'hevc', 'h264'];
